<template>
  <v-container>
    <div class="title-font-secondary" v-html="t('title')"></div>
    <div class="mt-3 mb-8">
      {{ t("subtitle") }}
      <v-tooltip content-class="pa-0 ma-0" right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            color="primary"
            class="material-icons-outlined mb-1"
            >help_outline</v-icon
          >
        </template>

        <v-card class="black--text" max-width="250px">
          <v-container class="text-center">
            <div class="mb-3">{{ t("help.title") }}</div>
            <div class="mb-1">{{ t("help.description") }}</div>
            <div class="subtitle-2 primary--text">{{$store.state.config.phoneNumber}}</div>
          </v-container>
        </v-card>
      </v-tooltip>
    </div>
    <v-card class="pa-0 ma-0">
      <v-tabs v-model="tab" background-color="white" grow dark>
        <v-tab
          v-for="(item, i) of tabs"
          :key="i"
          :disabled="tab !== i && !item.validate"
          :class="`${textColor(item)} font-weight-bold text-none`"
        >
          <span v-if="$root.isDesktop">{{ item.title }}</span>
          <v-icon
            v-if="$root.isDesktop"
            :color="iconColor(item)"
            class="material-icons-outlined ml-2"
            >{{ icon(item) }}</v-icon
          >
          <v-avatar v-else size="20" :color="avatarColor(item)"
            ><strong :class="avatarClass(item)">{{ i + 1 }}</strong></v-avatar
          >
        </v-tab>
      </v-tabs>
      <v-slider
        color="primary"
        :track-color="config.trackColor"
        readonly
        :value="config.position[tab]"
        class="mb-n4"
      ></v-slider>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <CompanyDataSection
            ref="section-0"
            :default-subdomain="defaultSubdomain"
          />
        </v-tab-item>
        <v-tab-item>
          <v-form ref="section-1">
            <ColorsSection />
          </v-form>
        </v-tab-item>
        <v-tab-item>
          <ImagesSection ref="section-2" />
        </v-tab-item>
      </v-tabs-items>
      <v-container>
        <v-row class="d-flex dense justify-end">
          <!--           <v-col cols="12" md="3" lg="2">
            <sc-btn
              @click="continueLater(tab)"
              outlined
              class="mr-3 mb-2"
              block
              >{{ t(tab != 2 ? "btnFillLater" : "btnGoUp") }}</sc-btn
            >
          </v-col> -->
          <v-col cols="12" md="3" lg="2">
            <sc-btn :loading="loading" @click="confirm(tab)" class="mb-2 mr-3" block>{{
              t("btnConfirm")
            }}</sc-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-container class="d-flex align-center flex-column my-5">
      <div class="my-5 title">{{ t("sitePreview") }}</div>
      <v-card
        height="500px"
        width="100%"
        class="d-flex flex-column justify-center align-center"
      >
        <iframe
          :key="previewKey"
          width="100%"
          height="100%"
          target="_parent"
          style="border: 1px solid black"
          :src="previewUrl"
        ></iframe>
      </v-card>
    </v-container>
    <v-dialog max-width="800px" v-model="dialog" persistent>
      <v-card class="rounded-lg d-flex flex-column">
        <v-btn
          fixed
          class="align-self-end mt-n12"
          color="primary"
          @click="dialog = false"
          small
          fab
          ><v-icon>clear</v-icon></v-btn
        >
        <v-container class="d-flex flex-column align-center">
          <v-icon color="primary" size="64" class="my-5">brush</v-icon>
          <div class="text-center my-5">
            <div>
              <p class="font-weight-bold subtitle-1">
                {{ t("dialog.title") }}
              </p>
            </div>
            <div>
              <p>
                {{ t("dialog.description") }}
              </p>
            </div>
          </div>
          <v-card-actions>
            <sc-btn min-width="140px" @click="finishedDesign">{{
              t("dialog.btn")
            }}</sc-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CompanyDataSection from "./CompanyDataSection";
import ColorsSection from "./ColorsSection";
import ImagesSection from "./ImagesSection";
import { mapState, mapMutations } from "vuex";
import { SET_DESIGNER_MODEL } from "@/constants/mutations-type";

export default {
  components: {
    CompanyDataSection,
    ColorsSection,
    ImagesSection,
  },
  data: (vm) => {
    const tabHelper = {
      validate: false,
      error: false,
    };
    return {
      tab: 0,
      previewUrl: null,
      previewKey: 0,
      dialog: false,
      loading: false,
      defaultSubdomain: null,
      tabs: [
        {
          title: vm.t("companyData.title"),
          ...tabHelper,
        },
        {
          title: vm.t("colors.title"),
          ...tabHelper,
        },
        {
          title: vm.t("images.title"),
          ...tabHelper,
        },
      ],
      config: {
        trackColor: "#CCD2D8",
        sliderColor: "primary",
        sliderClass: "slider-bottom mb-n2",
        position: [16, 50, 83],
      },
    };
  },
  computed: {
    ...mapState("designer", ["model"]),
  },
  mounted() {
    this.generatePreviewQuery();
    if (this.$route.params.id) {
      this.API.designer.show(this.$route.params.id).then((model) => {
        if (model.domain) {
          const temp = model.domain.split(".shuttlecentral.com");
          if (temp.length > 0) this.defaultSubdomain = temp[0];
        }
        const newModel = {
          ...model,
          settings: {
            ...model.settings,
            headerLogo: model.headerLogo,
            footerLogo: model.footerLogo,
            homeBanner: model.homeBanner,
          },
        };
        this[SET_DESIGNER_MODEL](newModel);
      });
    }
  },
  watch: {
    model: {
      handler() {
        this.generatePreviewQuery();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("designer", [SET_DESIGNER_MODEL]),
    t(key, options = {}) {
      return this.$t(`designer.${key}`, options);
    },

    icon: (item) => (!item.error ? "check_circle" : "error_outline"),
    avatarClass: ({ error, validate }) =>
      error ? "error--text" : validate ? "success--text" : "primary--text",
    iconColor: ({ error, validate }) =>
      error ? "error" : validate ? "success" : "grey",
    avatarColor: ({ error, validate }) =>
      error ? "error100" : validate ? "success100" : "primary100",
    textColor: ({ error, validate }) =>
      error ? "error--text" : validate ? "primary--text" : "black--text",

    serializeData() {
      let formData = new FormData();
      formData.append("domain", this.model.domain || "");
      formData.append("headerLogo", this.model.headerLogo || "");
      formData.append("footerLogo", this.model.footerLogo || "");
      formData.append("homeBanner", this.model.homeBanner || "");
      Object.entries(this.model.settings).forEach(([key, value]) => {
        formData.append(`settings[${key}]`, value || "");
      });
      return formData;
    },
    finishedDesign() {
      const formData = this.serializeData();
      this.dialog = false;
      this.loading = true;
      if (this.$route.params.id) {
        const id = this.$route.params.id;
        this.API.designer
          .update(formData, id)
          .then(() => {
            this.$router.push(`/designer/${id}/finish`);
          })
          .catch(() => alert("Error"))
          .finally(() => (this.loading = false));
      } else {
        this.API.designer
          .create(formData)
          .then(({ id }) => {
            this.$router.push(`/designer/${id}/finish`);
          })
          .catch(() => alert("Error"))
          .finally(() => (this.loading = false));
      }
    },
    mapParams: (params, object) =>
      Object.entries(object).reduce(
        (acc, [key, value]) =>
          value ? (acc += `&${key}=${encodeURIComponent(value)}`) : acc,
        params
      ),
    generatePreviewQuery() {
      let url = `${process.env.VUE_APP_ENGINE}/?previewMode=true`;
      const object = JSON.parse(JSON.stringify(this.model));
      //Se se mapea el objeto settings
      url = this.mapParams(url, object.settings);
      //Se elimina el objeto settings para mapear el resto del modelo
      delete object.settings;
      //Se mapea el resto del modelo excepto settings
      this.previewUrl = url;
      //Se recarga el iframe
      this.previewKey++;
    },
    isValidTab(tab) {
      const section = `section-${tab}`;
      const validationStatus = this.$refs[section].validate();
      this.tabs[tab].validate = validationStatus;
      this.tabs[tab].error = !validationStatus;
      return validationStatus;
    },
    continueLater(tab) {
      this.tabs[tab].validate = true;
      this.tabs[tab].error = false;
      if (tab !== 2) {
        this.tab++;
      } else {
        this.dialog = true;
      }
    },
    confirm(tab) {
      if (!this.isValidTab(tab)) return;
      if (tab !== 2) {
        this.tab++;
      } else {
        this.finishedDesign();
      }
    },
  },
};
</script>

<style lang="scss">
.v-slider--horizontal {
  min-height: 0px;
  margin-left: 0px;
  margin-right: 0px;
}

</style>
